import React from "react";
const Mail = () => {
  return (
    <div>
      <a href="mailto:bharath.com006@gmail.com" target="_blank">
        <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          width="42px"
          height="42px"
          viewBox="0 0 344.000000 344.000000"
          preserveAspectRatio="xMidYMid meet"
        >
          <g
            transform="translate(0.000000,344.000000) scale(0.100000,-0.100000)"
            fill="#FFFFFF"
          >
            <path
              d="M490 2861 c-89 -28 -170 -107 -170 -167 0 -18 5 -44 12 -58 8 -19
            187 -136 632 -413 342 -213 640 -398 664 -411 55 -31 123 -32 178 -4 109 58
            1270 801 1288 825 34 46 27 100 -20 149 -22 22 -57 49 -79 61 l-40 22 -1220 2
            c-671 1 -1231 -2 -1245 -6z"
            />
            <path
              d="M3050 2277 c-14 -7 -306 -191 -650 -408 l-625 -394 -55 0 -55 0 -640
            399 c-686 428 -685 428 -727 377 -18 -23 -19 -49 -16 -745 3 -711 3 -722 24
            -767 26 -55 79 -111 137 -141 l42 -23 1235 0 1235 0 42 23 c58 30 111 86 137
            141 21 45 21 56 24 772 2 684 2 727 -15 747 -24 28 -62 36 -93 19z"
            />
          </g>
        </svg>
      </a>
    </div>
  );
};

export default Mail;
